/**
 * Valida si una cadena es una fecha válida en formato YYYY-MM-DD.
 * @param {string} dateString
 * @returns {boolean}
 */
export function isValidDate(dateString) {
    return moment(dateString, 'YYYY-MM-DD', true).isValid()
}

/**
 * Formatea una fecha o nombre de día de la semana para visualización.
 * Si date es YYYY-MM-DD válido: "LUNES 01/03"
 * Si date es weekday en inglés (sunday, monday...): nombre localizado en mayúsculas.
 * @param {string} date - Fecha YYYY-MM-DD o nombre de día en inglés
 * @returns {string}
 */
export function formatDate(date) {
    if (isValidDate(date)) {
        return moment(date).locale(localStorage.language).format('dddd').toUpperCase() + ' ' + moment(date).format('DD/MM')
    }
    const localWeekdays = moment.weekdays()
    const englishWeekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    const weekdayIndex = englishWeekdays.indexOf(date)
    return localWeekdays[weekdayIndex].toUpperCase()
}
